import Button from '@ui-library/button';
import React, { useState } from 'react';
import { useTransition, animated } from 'react-spring';
import ErrorModal from '@ui-library/modal/error';
import ErrorMessageView from '@components/sources/sourceDetails/cloudSourceDetails/cloudSourceReports/errors/ErrorMessageView';
import { get } from 'lodash';
import classes from './common.module.scss';

export interface ErrorAssetProps {
  errMessage?: string;
  reloadMessage?: string;
  errorModalContent?: string;
}

export interface ErrorProps {
  type: string;
  errorAssets: ErrorAssetProps;
}
interface ErrorsViewProp {
  errors: Record<string, ErrorAssetProps>;
}

export const fetchErrorAssets = (type: string, errMsg?: string) => {
  let reloadMessage;
  const errMessage = `Couldn't fetch ${type}`;
  switch (type) {
    case 'schemas':
      reloadMessage = 'reload schemas and tables';
      break;
    case 'tables':
      reloadMessage = 'reload schemas and tables';
      break;
    case 'columns':
      reloadMessage = 'reload columns';
      break;
    case 'fields':
      reloadMessage = 'reload fields';
      break;
    case 'preview':
      reloadMessage = 'reload preview';
      break;
    default:
      reloadMessage = '';
      break;
  }
  const error: ErrorProps = {
    type,
    errorAssets: errMsg ? { errMessage, reloadMessage, errorModalContent: errMsg } : {},
  };
  return error;
};

const ErrorsView: React.FC<ErrorsViewProp> = ({ errors }: ErrorsViewProp) => {
  const [errorModalValues, setErrorModalValues] = useState<ErrorAssetProps>({});
  const errorArr = Object.keys(errors)
    .map((type: string) => ({
      type,
      ...get(errors, type, { errMessage: '', reloadMessage: '', errorModalContent: '' }),
    }))
    .filter((curr) => curr.errMessage);
  const transition = useTransition(errorArr, {
    from: { opacity: 0, transform: 'translate3d(0,100%,0)' },
    enter: { opacity: 100, transform: 'translate3d(0,0,0)' },
    delay: 200,
    native: true,
    keys: errorArr.map((item, index) => index),
  });

  return (
    <div className={classes.error_view_container} data-testid="error">
      {errorModalValues.errMessage && errorModalValues.errorModalContent && (
        <ErrorModal
          header={errorModalValues.errMessage}
          subHeader=""
          view={<ErrorMessageView errorMessage={errorModalValues.errorModalContent} />}
          onClose={() => {
            setErrorModalValues({});
          }}
          showBackButton={false}
          clipboardContent={errorModalValues.errMessage + errorModalValues.errorModalContent}
        />
      )}

      {transition((styles, errorAssets: ErrorAssetProps) => (
        <animated.div className={classes.error_view} style={styles}>
          <div className={classes.animated}>
            {errorAssets.errMessage}
            {'. '}
            Click{' '}
            <Button
              textPrimary
              className={classes.error_button}
              onClick={() => {
                setErrorModalValues(errorAssets);
              }}
              name="here"
            />
            {' to check error'}
            {errorAssets.reloadMessage ? ` or ${errorAssets.reloadMessage}` : ''}.
          </div>
        </animated.div>
      ))}
    </div>
  );
};
export default ErrorsView;
